import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  iconWrapper: {
    color: theme.palette.select.light,
    cursor: 'pointer',
    fontSize: '16px',
    gap: theme.spacing(0.5),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: theme.spacing(2.5),
  },
  text: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  divider: {
    height: '20px',
    marginRight: theme.spacing(2.5),
    border: `1px solid ${theme.palette.dividerV2.main}`,
  },
  actionWithDivider: {
    display: 'flex',
    flexDirection: 'row',
  },
}))
